import { h } from 'preact';
export const CapacityBar = ({ usedPct , remainingCapacityPresentation  })=>h('div', {
        className: 'capacity-preview'
    }, [
        h('div', {
            className: 'capacity-preview__bar'
        }, h('div', {
            style: {
                backgroundColor: usedPct >= 100 ? 'green' : '#1e3e6a',
                width: `${usedPct}%`,
                height: '100%'
            }
        })),
        h('div', {
            style: {
                fontSize: '12px',
                marginTop: '6px'
            }
        }, `Remaining: ${remainingCapacityPresentation} — ${100 - usedPct}% free`)
    ]);
